import { isProduction } from '../environment';
import { CalendarApi as RealCalendarApi } from './calendar-api';
import { CalendarApi as MockCalendarApi } from './mock-calendar-api';

// Select the concrete implementation based on environment.
const SelectedCalendarApi = isProduction() ? RealCalendarApi : MockCalendarApi;

export default SelectedCalendarApi;